var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85405 25.6261C2.31259 25.5404 1.3706 19.9312 1.75596 13.0803C2.14132 6.22944 3.72559 0.748728 5.26705 0.834364C6.8085 0.92 7.75049 6.52917 7.36513 13.3801C6.97977 20.231 5.3955 25.7117 3.85405 25.6261Z",
    fill: "url(#paint0_linear_1_321)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10998 24.3845C2.69698 24.2989 1.84062 19.2464 2.18316 13.0806C2.52571 6.91474 3.93871 1.99066 5.35171 2.0763C6.72189 2.16193 7.57825 7.21447 7.2357 13.3803C6.89316 19.5461 5.48016 24.4702 4.10998 24.3845V24.3845Z",
    fill: "url(#paint1_linear_1_321)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06569 13.38C7.40823 7.29986 6.59469 2.33296 5.26733 2.07605C5.29588 2.07605 5.32442 2.07605 5.35297 2.07605C6.72314 2.16169 7.57951 7.21423 7.23696 13.38C6.89442 19.5458 5.48142 24.4699 4.11124 24.3843C4.08269 24.3843 4.05415 24.3843 4.0256 24.3843C5.39578 24.2558 6.72314 19.4174 7.06569 13.38Z",
    fill: "#7E470D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6826 0.748564L5.26687 0.834202C3.72542 0.748566 2.14115 6.22928 1.75578 13.0802C1.37042 19.9311 2.31242 25.5403 3.85387 25.6259L2.31242 25.5403C0.770969 25.4546 -0.17103 19.8454 0.214333 12.9945C0.599696 6.14365 2.14115 0.662928 3.6826 0.748564V0.748564Z",
    fill: "url(#paint2_linear_1_321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_321",
    x1: -0.299311,
    y1: 26.9106,
    x2: 8.99222,
    y2: 27.8098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_321",
    x1: 16.9126,
    y1: 1.09148,
    x2: 1.06989,
    y2: 0.235116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_321",
    x1: -0.385121,
    y1: -0.0649803,
    x2: -1.88375,
    y2: 26.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/coin3.73f3129be0713fede5847da69387f980.svg";
export { ForwardRef as ReactComponent };